module.exports = __webpack_public_path__ + "img/independent-reader.ea2a42cc.png";